import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Typography } from '@guildeducationinc/recess';
import { AddCommentButton } from '@src/components/AddCommentButton';
import { CommentCard } from '@src/components/CommentCard';
import { useAuth } from '@src/hooks/useAuth';
import { useComments, useCommentsSingleExpense } from '@src/hooks/useComments';
import { useLocale } from 'pe-core-frontend';
import { useEffect, useState } from 'react';
import styles from './CommentsList.module.scss';
export const CommentsList = ({ commentableType, commentableId, clientId, isInternal, forceUpdate = undefined, onCommentAdded, allowAddComment = true, tag, isSingleExpense, programId, paymentRequestId, }) => {
    const { t } = useLocale();
    const { currentUser } = useAuth();
    // For single expense flow, query both program and payment request comments
    const singleExpenseComments = useCommentsSingleExpense({
        programId: programId,
        paymentRequestId: paymentRequestId,
        isInternal,
        skip: !isSingleExpense || !currentUser,
    });
    // For regular flow, query single commentable
    const regularComments = useComments({
        commentableId,
        commentableType,
        isInternal,
        skip: isSingleExpense || !currentUser,
    });
    // Use the appropriate query result based on flow type
    const { comments, error, loading, refetch } = isSingleExpense
        ? singleExpenseComments
        : regularComments;
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    useEffect(() => {
        if (isInitialLoad && !loading) {
            setIsInitialLoad(false);
        }
    }, [loading, isInitialLoad]);
    useEffect(() => {
        if (forceUpdate !== undefined) {
            refetch();
        }
    }, [forceUpdate]);
    const handleAfterAdd = async () => {
        await refetch();
        onCommentAdded && onCommentAdded();
    };
    if (isInitialLoad) {
        return null;
    }
    const title = isInternal ? t('Notes') : t('Comments');
    const noDataText = isInternal ? t('No notes found') : t('No comments found');
    return (_jsxs("div", { className: styles.container, children: [_jsx(Typography, { variant: 'title3', children: title }), error && (_jsx(Alert, { display: true, hideClose: true, type: 'danger', children: t('Unable to load comments') })), (comments.length > 0 &&
                comments.map((comment) => _jsx(CommentCard, { comment: comment }, comment.id))) ||
                noDataText, allowAddComment && (_jsx("div", { children: _jsx(AddCommentButton, { commentableType: commentableType, commentableId: commentableId, isInternal: isInternal ?? false, clientId: clientId, buttonText: isInternal ? t('Add Note') : t('Add Comment'), onAdd: handleAfterAdd, tag: tag, required: true }) }))] }));
};
